module.exports = __webpack_public_path__ + "img/bg_daoyou@2x.a79d746a.png";